import Component from '../Component';
import React from 'react';

export default class IconCheckbox extends Component {

	static defaultProps = {
		color: '#666666',
		disabled: false
	};

	handleChange() {
		if (!this.props.disabled) {
			this.props.onChange(!this.props.value);
			if (this.props.onBlur) {
				this.props.onBlur(!this.props.value);
			}
		}
	}

	render() {
		const checked = !!this.props.value;
		const cn = checked ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked';
		const color = this.props.disabled ? '#DDD' : this.props.color;
		const cursor = this.props.disabled ? 'not-allowed' : null;
		return (
			<div style={{cursor: cursor, display: 'inline'}} onClick={() => this.handleChange()}>
				<span style={{color:color, fontSize: 14}} className={cn}></span>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/IconCheckbox.js